import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default props => {
    const map = useMapContext()
    const {mapTypeCode} = map.data

    if ('_DB_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => {
        const {pkid: dbId, dbName, prjId, sVer} = map.root.data

        openWindow(
            '/Ai',

            {
                bizMap: {dbId, prjId, sVer},
                prjId,
                scene: 'GENERATE_TRD',
                sVer,
                title: `数据库: ${dbName}`,
            }
        )
    }

    return {
        label: '业务对象建模',
        onClick,
        ...props
    }
}
